export interface Comic {
  id: string;
  title: string;
  altTitle: string;
  category: string;
  tags: string[];
  status: "连载中" | "已完结";
  episodes: number;
  latestChapter: string;
  updateTime: string;
  author: string;
  description: string;
  rating: number;
  cover: string;
  hot?: boolean;
  recommend?: boolean;
}

export const comics: Comic[] = [
  {
    id: "ranxue-qiyue",
    title: "燃血契约",
    altTitle: "燃血之约",
    category: "热血冒险",
    tags: ["热血", "战斗", "成长"],
    status: "连载中",
    episodes: 168,
    latestChapter: "第168话 觉醒之力",
    updateTime: "今日 08:30",
    author: "苍焰工作室",
    description:
      "少年林焰在家族的古老契约觉醒之夜，被一只神秘的火焰巨兽选中，从此踏上寻找失落的九种契约之力的旅程。热血燃烧的战斗、羁绊与背叛交织，一部让人欲罢不能的燃向冒险长篇。",
    rating: 9.4,
    hot: true,
    recommend: true,
    cover: "https://readdy.ai/api/search-image?query=dynamic%20anime%20manga%20cover%20illustration%20of%20a%20young%20hero%20wreathed%20in%20roaring%20orange%20and%20red%20flames%2C%20intense%20battle%20pose%2C%20fiery%20energy%20swirl%20behind%20him%2C%20vibrant%20warm%20colors%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art%2C%20dramatic%20lighting&width=600&height=800&seq=cover-01&orientation=portrait",
  },
  {
    id: "jiuxiao-jianlai",
    title: "九霄剑来",
    altTitle: "剑来九霄",
    category: "奇幻仙侠",
    tags: ["仙侠", "剑修", "热血"],
    status: "连载中",
    episodes: 215,
    latestChapter: "第215话 渡劫之变",
    updateTime: "今日 08:00",
    author: "青云漫社",
    description:
      "凡尘少年偶得上古剑胚，一柄断剑闯九霄。在宗门倾轧与天地大劫之间，他一步步悟出属于自己的剑道。剑修世界波澜壮阔，道心与情义并重。",
    rating: 9.2,
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20swordsman%20wielding%20a%20glowing%20celestial%20sword%20amid%20floating%20clouds%20and%20mountains%2C%20wuxia%20fantasy%20style%2C%20elegant%20jade%20and%20gold%20tone%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art%2C%20mystical%20atmosphere&width=600&height=800&seq=cover-02&orientation=portrait",
  },
  {
    id: "dushi-yexingzhe",
    title: "都市夜行者",
    altTitle: "夜行者",
    category: "都市生活",
    tags: ["都市", "悬疑", "热血"],
    status: "连载中",
    episodes: 126,
    latestChapter: "第126话 幕后黑手",
    updateTime: "今日 07:40",
    author: "午夜漫画",
    description:
      "白天是普通上班族，夜晚化身为守护城市的夜行者。在一桩桩看似互不相干的都市迷案背后，隐藏着足以颠覆整座城市的巨大阴谋。",
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20mysterious%20hero%20silhouette%20on%20a%20rainy%20neon%20city%20rooftop%20at%20night%2C%20urban%20noir%20thriller%20mood%2C%20cool%20teal%20and%20warm%20amber%20city%20lights%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-03&orientation=portrait",
  },
  {
    id: "chunri-gaobai",
    title: "春日告白计划",
    altTitle: "春天要勇敢",
    category: "校园青春",
    tags: ["校园", "青春", "恋爱"],
    status: "连载中",
    episodes: 74,
    latestChapter: "第74话 心跳加速",
    updateTime: "今日 07:20",
    author: "柠檬气泡",
    description:
      "高三转学生许澄第一天就喜欢上了全班最受欢迎的班长，于是制定了一份超详细的『春日告白计划』。轻松欢快的校园恋爱喜剧，甜度刚刚好。",
    rating: 9.0,
    recommend: true,
    cover: "https://readdy.ai/api/search-image?query=soft%20anime%20manga%20cover%20illustration%20of%20a%20bashful%20high%20school%20couple%20under%20blooming%20cherry%20blossoms%20in%20spring%2C%20sweet%20romantic%20comedy%20mood%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-04&orientation=portrait",
  },
  {
    id: "miwu-dangan",
    title: "迷雾档案",
    altTitle: "档案迷雾",
    category: "悬疑推理",
    tags: ["悬疑", "推理", "单元剧"],
    status: "连载中",
    episodes: 132,
    latestChapter: "第132话 双重真相",
    updateTime: "昨日 22:00",
    author: "暗房工作室",
    description:
      "一间神秘的『迷雾档案室』，藏着城市里所有无解案件的卷宗。实习记录员小何在整理档案的过程中，一步步揭开那些被岁月尘封的惊人真相。",
    rating: 9.1,
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20detective%20opening%20a%20dusty%20old%20file%20folder%20in%20a%20dimly%20lit%20archive%20room%2C%20mystery%20suspense%20mood%2C%20smoky%20neutral%20and%20deep%20amber%20tones%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-05&orientation=portrait",
  },
  {
    id: "yueguang-bianlidian",
    title: "月光便利店",
    altTitle: "深夜便利店的奇遇",
    category: "恋爱治愈",
    tags: ["治愈", "恋爱", "日常"],
    status: "连载中",
    episodes: 96,
    latestChapter: "第96话 温暖的夜",
    updateTime: "昨日 21:30",
    author: "暖灯漫画",
    description:
      "开在街角深夜的月光便利店，每晚都迎来不同的客人，也悄悄发生着温暖人心的故事。店主与常客之间，一段细水长流的治愈之恋缓缓展开。",
    rating: 9.3,
    recommend: true,
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20manga%20cover%20illustration%20of%20a%20warm%20glowing%20convenience%20store%20at%20night%20under%20a%20full%20moon%2C%20healing%20slice%20of%20life%20mood%2C%20soft%20warm%20yellow%20light%20and%20tranquil%20blue%20night%20sky%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-06&orientation=portrait",
  },
  {
    id: "xingqiong-jiyuan",
    title: "星穹纪元",
    altTitle: "星辰纪元",
    category: "科幻末世",
    tags: ["科幻", "太空", "冒险"],
    status: "连载中",
    episodes: 158,
    latestChapter: "第158话 引力风暴",
    updateTime: "昨日 20:10",
    author: "轨道工作室",
    description:
      "太阳系资源枯竭后，人类启动了『星穹计划』，踏上寻找第二家园的漫长旅途。在深邃的宇宙中，关于起源与命运的终极秘密逐渐浮出水面。",
    rating: 9.0,
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=epic%20anime%20manga%20cover%20illustration%20of%20a%20starship%20sailing%20through%20a%20nebula%20of%20vibrant%20violet%20and%20orange%20stardust%2C%20sci%20fi%20space%20adventure%20mood%2C%20cosmic%20wonder%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-07&orientation=portrait",
  },
  {
    id: "feitu-yusheng",
    title: "废土余生",
    altTitle: "废土之上",
    category: "科幻末世",
    tags: ["末世", "生存", "热血"],
    status: "已完结",
    episodes: 210,
    latestChapter: "第210话 新的黎明（完结）",
    updateTime: "2026-07-30",
    author: "荒原绘社",
    description:
      "浩劫之后的世界满目疮痍，幸存者们为了一线生机在废土上挣扎求生。少年与同伴们在废墟中重建家园的故事，残酷中带着不灭的希望。",
    rating: 8.8,
    cover: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20anime%20manga%20cover%20illustration%20of%20a%20lone%20survivor%20standing%20before%20a%20ruined%20city%20under%20a%20dusty%20sun%2C%20wasteland%20survival%20mood%2C%20muted%20earthy%20tones%20with%20warm%20sunlight%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-08&orientation=portrait",
  },
  {
    id: "maomi-kafeiguan",
    title: "猫咪咖啡馆物语",
    altTitle: "喵喵咖啡馆",
    category: "恋爱治愈",
    tags: ["治愈", "日常", "萌系"],
    status: "连载中",
    episodes: 52,
    latestChapter: "第52话 温柔的午后",
    updateTime: "昨日 19:40",
    author: "软软漫游",
    description:
      "一家开在转角的老咖啡馆，五只性格各异的猫咪店员，和一群来寻找慰藉的客人。在这里，每一杯咖啡都盛着一份温暖的小故事。",
    rating: 9.5,
    recommend: true,
    cover: "https://readdy.ai/api/search-image?query=adorable%20anime%20manga%20cover%20illustration%20of%20a%20fluffy%20cafe%20cat%20wearing%20a%20tiny%20apron%20holding%20a%20coffee%20cup%2C%20cozy%20cafe%20vibe%2C%20warm%20beige%20and%20cream%20palette%20with%20soft%20brown%20accents%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-09&orientation=portrait",
  },
  {
    id: "chaonengli-xueyuan",
    title: "超能力学园",
    altTitle: "觉醒学园",
    category: "热血冒险",
    tags: ["超能力", "学园", "热血"],
    status: "连载中",
    episodes: 88,
    latestChapter: "第88话 天赋测试",
    updateTime: "今日 06:50",
    author: "电光石火",
    description:
      "一群觉醒了超能力的学生，进入培养守护者的特殊学园。性格各异的少年少女们，在一次次危机与考验中，学会使用能力，也学会守护珍视之人。",
    rating: 8.7,
    cover: "https://readdy.ai/api/search-image?query=energetic%20anime%20manga%20cover%20illustration%20of%20a%20group%20of%20students%20surrounded%20by%20glowing%20electric%20and%20elemental%20powers%20on%20a%20school%20campus%2C%20superhero%20academy%20mood%2C%20bright%20vibrant%20warm%20colors%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-10&orientation=portrait",
  },
  {
    id: "diwuge-chengke",
    title: "第五个乘客",
    altTitle: "末班车迷案",
    category: "悬疑推理",
    tags: ["悬疑", "惊悚", "单元剧"],
    status: "连载中",
    episodes: 60,
    latestChapter: "第60话 终点站",
    updateTime: "2026-08-15",
    author: "子夜物语",
    description:
      "每晚十一点的末班地铁，车厢里总有五个人。可当第五个乘客出现时，故事的走向将完全颠覆。一部氛围感拉满的都市惊悚悬疑。",
    rating: 8.9,
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20anime%20manga%20cover%20illustration%20of%20an%20empty%20midnight%20subway%20car%20with%20a%20mysterious%20passenger%20in%20the%20shadows%2C%20suspense%20thriller%20mood%2C%20dim%20cold%20blue%20with%20warm%20amber%20seats%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-11&orientation=portrait",
  },
  {
    id: "shenhai-jinyu",
    title: "深海禁域",
    altTitle: "深渊之下",
    category: "奇幻仙侠",
    tags: ["奇幻", "冒险", "探索"],
    status: "连载中",
    episodes: 41,
    latestChapter: "第41话 幽蓝之眼",
    updateTime: "2026-08-14",
    author: "蔚蓝绘图社",
    description:
      "人类对深海禁域的探索从未停止。一支神秘考察队潜入万米深渊，发现了一片拥有自己生态与文明的失落世界。未知与美丽并存，危险亦随之而来。",
    rating: 8.6,
    cover: "https://readdy.ai/api/search-image?query=mystical%20anime%20manga%20cover%20illustration%20of%20an%20underwater%20explorer%20facing%20a%20bioluminescent%20deep%20sea%20ruins%20with%20a%20giant%20glowing%20eye%2C%20deep%20ocean%20fantasy%20mood%2C%20deep%20teal%20and%20glowing%20turquoise%20tones%2C%20clean%20minimal%20background%2C%20high%20detail%20digital%20art&width=600&height=800&seq=cover-12&orientation=portrait",
  },
];

export const getComicById = (id: string): Comic | undefined =>
  comics.find((c) => c.id === id);

export const getLatestUpdates = (): Comic[] =>
  [...comics].sort((a, b) => b.rating - a.rating);

export const getHotComics = (): Comic[] => comics.filter((c) => c.hot);

export const getRecommended = (): Comic[] => comics.filter((c) => c.recommend);

export const getByCategory = (category: string): Comic[] =>
  category === "all" ? comics : comics.filter((c) => c.category === category);